// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"237":"2979ff84","506":"7eb735f5","746":"3a1ad53d"}[chunkId] + ".js";
};